import { render, staticRenderFns } from "./AscGdprNotification.vue?vue&type=template&id=6ef51510&"
import script from "./AscGdprNotification.vue?vue&type=script&lang=js&"
export * from "./AscGdprNotification.vue?vue&type=script&lang=js&"
import style0 from "./AscGdprNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports